module.exports = __webpack_public_path__ + "img/pdf.45e20b2b.jpg";